<template>
  <transition-group name="product" tag="div" class="flexbox" appear>
    <div
      v-for="product in products"
      :key="product.id"
      class="col col-33 col-m-50 col-s-full"
    >
      <app-item :product="product"></app-item>
    </div>
  </transition-group>
</template>

<script>
import Item from "./Item.vue";
export default {
  components: {
    appItem: Item,
  },
  props: {
    products: Array,
  },
};
</script>

<style lang="scss" scoped>
.col {
  transition: all 0.5s;
}
.product-enter {
  opacity: 0;
  transform: translateY(5px) scale(0.5);
}
.product-leave-to {
  opacity: 0;
  transform: translateY(5px) scale(0.5);
}
.product-leave-active {
  position: absolute;
  opacity: 0;
}
.product-move {
  transition: transform 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/product/Grid.vue